import React from 'react'

export default function CardPaymentRedirect() {
    return (
        <div>CardPaymentRedirect</div>
    )
}
